module.exports = "https://static.im-cdn.com/mjc/storefront/Coral/static/media/RedXMark.e068f5c5.svg";